import { DraftBadge } from 'src/components/draft-badge';

import { usePreviewMode } from '#/features/community-hub/hooks/use-preview-mode';

import { ResourceCard } from './resource-card';
import type { CardProps } from './types';

/** Form block tile — managers previewing also see whether the form is still a draft. */
export const FormCard = ({ block, onClick }: CardProps) => {
  const { isPreview } = usePreviewMode();
  const isUnpublishedForm = block.formStatus !== 'published';

  return (
    <ResourceCard block={block} onClick={onClick} caption={block.title || 'Form'} bannerUrl={block.textBannerUrl}>
      {isPreview && isUnpublishedForm && <DraftBadge />}
    </ResourceCard>
  );
};
